// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Compact three-level left nav (inline mode only).
 * Colors come from the antd theme via CSS variables set on the Sider in LeftNav.tsx.
 */

.ib-left-nav.ant-menu-inline .ant-menu-sub.ant-menu-inline {
  background: transparent;
}

/* Level 2 */
.ib-left-nav.ant-menu-inline > .ant-menu-submenu > .ant-menu-sub > .ant-menu-item,
.ib-left-nav.ant-menu-inline > .ant-menu-submenu > .ant-menu-sub > .ant-menu-submenu > .ant-menu-submenu-title {
  height: 36px;
  line-height: 36px;
}

/* Level 3: hang off a guide line under the level 2 label */
.ib-left-nav.ant-menu-inline .ant-menu-sub .ant-menu-sub.ant-menu-inline {
  margin-inline-start: 44px;
  border-inline-start: 1px solid var(--ib-nav-guide);
}

.ib-left-nav.ant-menu-inline .ant-menu-sub .ant-menu-sub > .ant-menu-item {
  height: 32px;
  line-height: 32px;
  font-size: 13px;
  padding-inline-start: 14px !important;
  margin-inline: 0 4px;
  width: calc(100% - 4px);
  border-radius: 0 6px 6px 0;
}

.ib-left-nav.ant-menu-inline .ant-menu-sub .ant-menu-sub > .ant-menu-item-selected {
  box-shadow: inset 2px 0 0 var(--ib-nav-active);
}
`, "",{"version":3,"sources":["webpack://./client/styles/leftNav.override.css"],"names":[],"mappings":"AAAA;;;EAGE;;AAEF;EACE,uBAAuB;AACzB;;AAEA,YAAY;AACZ;;EAEE,YAAY;EACZ,iBAAiB;AACnB;;AAEA,2DAA2D;AAC3D;EACE,yBAAyB;EACzB,kDAAkD;AACpD;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,qCAAqC;EACrC,oBAAoB;EACpB,uBAAuB;EACvB,0BAA0B;AAC5B;;AAEA;EACE,8CAA8C;AAChD","sourcesContent":["/*\n * Compact three-level left nav (inline mode only).\n * Colors come from the antd theme via CSS variables set on the Sider in LeftNav.tsx.\n */\n\n.ib-left-nav.ant-menu-inline .ant-menu-sub.ant-menu-inline {\n  background: transparent;\n}\n\n/* Level 2 */\n.ib-left-nav.ant-menu-inline > .ant-menu-submenu > .ant-menu-sub > .ant-menu-item,\n.ib-left-nav.ant-menu-inline > .ant-menu-submenu > .ant-menu-sub > .ant-menu-submenu > .ant-menu-submenu-title {\n  height: 36px;\n  line-height: 36px;\n}\n\n/* Level 3: hang off a guide line under the level 2 label */\n.ib-left-nav.ant-menu-inline .ant-menu-sub .ant-menu-sub.ant-menu-inline {\n  margin-inline-start: 44px;\n  border-inline-start: 1px solid var(--ib-nav-guide);\n}\n\n.ib-left-nav.ant-menu-inline .ant-menu-sub .ant-menu-sub > .ant-menu-item {\n  height: 32px;\n  line-height: 32px;\n  font-size: 13px;\n  padding-inline-start: 14px !important;\n  margin-inline: 0 4px;\n  width: calc(100% - 4px);\n  border-radius: 0 6px 6px 0;\n}\n\n.ib-left-nav.ant-menu-inline .ant-menu-sub .ant-menu-sub > .ant-menu-item-selected {\n  box-shadow: inset 2px 0 0 var(--ib-nav-active);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
